import React, { useState } from 'react';
import logo from '../../../assests/images/logo.png';

export const Nav = () => {

  const [clicked, setClicked] = useState(false)

  const handleCLick = () => {
    setClicked(!clicked)
    setTimeout(() => {
      setClicked(false)
    }, 3000)
  }

  return (
    <div className='nav'>
      <div className='logo'>
        <span className='license-heading' onClick={handleCLick}>License</span>
        <img className='image' width={'22px'} height={'22px'} src={logo} alt="Epidemic" />
      </div>
      <div className='cross'>
      </div>
      <div style={{ display: clicked === true ? '' : 'none' }} className='license'>
        <p className='license-content'>All of these music can be used only for personal use.
          Tap the Get more button below if you want to use it
          for commercial use.
        </p>
      </div>
    </div>
  )
}